'use strict';

function downloadName(disposition, trialId) {
  const fallback = `trial-${trialId}-raw.csv`;
  if (typeof disposition !== 'string') return fallback;
  const quoted = disposition.match(/filename="([^"]+)"/);
  const plain = disposition.match(/filename=([^;\s]+)/);
  const raw = quoted ? quoted[1] : (plain ? plain[1] : '');
  const base = raw.replace(/\\/g, '/').split('/').pop();
  if (!base || base === '.' || base === '..') return fallback;
  return base;
}

function saveBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
}

/**
 * Download one trial's angle and sensor series.
 * GET {SERVER_URL}/a/export-trial-raw?trial_id=
 */
export async function exportTrialRaw(trialId) {
  if (trialId == null || trialId === '') {
    throw new Error('trial id required');
  }
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('missing token');
  }
  const response = await fetch(
    `${window.SERVER_URL}/a/export-trial-raw?trial_id=${encodeURIComponent(trialId)}`,
    { headers: { Authorization: 'Bearer ' + token } }
  );
  if (!response.ok) {
    throw new Error(`export trial raw HTTP ${response.status}`);
  }
  const contentType = response.headers.get('Content-Type') || '';
  if (!contentType.toLowerCase().startsWith('text/csv')) {
    throw new Error('export trial raw expected text/csv');
  }
  const filename = downloadName(response.headers.get('Content-Disposition'), trialId);
  saveBlob(await response.blob(), filename);
  return filename;
}
